module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.loading) ? _c('div', [_c('loader')], 1) : _c('div', [_c('div', {
    staticClass: "form"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "name"
    }
  }, [_vm._v("Nome")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newField.name),
      expression: "newField.name"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "name",
      "placeholder": "Nome"
    },
    domProps: {
      "value": (_vm.newField.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newField, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "description"
    }
  }, [_vm._v("Descrição")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newField.description),
      expression: "newField.description"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "description",
      "placeholder": "Descrição"
    },
    domProps: {
      "value": (_vm.newField.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newField, "description", $event.target.value)
      }
    }
  })]), _vm._v(" "), (!_vm.hideRequired) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "required"
    }
  }, [_vm._v("Obrigatório")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newField.required),
      expression: "newField.required"
    }],
    attrs: {
      "id": "required",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.newField.required) ? _vm._i(_vm.newField.required, null) > -1 : (_vm.newField.required)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.newField.required,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.newField, "required", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.newField, "required", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.newField, "required", $$c)
        }
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "type"
    }
  }, [_vm._v("Tipo")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newField.type),
      expression: "newField.type"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "type",
      "placeholder": "Tipo"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.newField, "type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        return _vm.change()
      }]
    }
  }, _vm._l((_vm.fieldTypes), function(fieldType) {
    return _c('option', {
      domProps: {
        "value": fieldType
      }
    }, [_vm._v(_vm._s(fieldType))])
  }), 0)]), _vm._v(" "), (_vm.showFormula) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('label', {
    attrs: {
      "for": "formula"
    }
  }, [_vm._v("Fórmula")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newField.formula),
      expression: "newField.formula"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "formula",
      "rows": "2",
      "placeholder": "Adicione uma fórmula aqui, considerando o NOME dos outros campos. Exemplo: concat( (Idade do Requisitante + 65).toString(), \"anos\"). Mais detalhes sobre as formulas http://mathjs.org/docs/index.html"
    },
    domProps: {
      "value": (_vm.newField.formula)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newField, "formula", $event.target.value)
      }
    }
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Regras")]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [(_vm.rules.length === 0) ? _c('div', {
    staticClass: "alert alert-info"
  }, [_vm._v("Nenhuma regra de redirecionamento")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.rules), function(rule, index) {
    return _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-sm-2"
    }, [_c('label', [_vm._v("Operação")]), _vm._v(" "), _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (rule.operation),
        expression: "rule.operation"
      }],
      staticClass: "form-control",
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(rule, "operation", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, _vm._l((_vm.fieldRules), function(opt) {
      return _c('option', [_vm._v(_vm._s(opt))])
    }), 0)]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-4"
    }, [_c('label', [_vm._v("Argumento")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (rule.argument),
        expression: "rule.argument"
      }],
      staticClass: "form-control",
      domProps: {
        "value": (rule.argument)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(rule, "argument", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-4"
    }, [_c('label', [_vm._v("Ir para seção")]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "label": "name",
        "track-by": "objectId",
        "options": _vm.sections,
        "showLabels": false,
        "placeholder": "Selecione uma opção"
      },
      model: {
        value: (rule.goto),
        callback: function($$v) {
          _vm.$set(rule, "goto", $$v)
        },
        expression: "rule.goto"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "col-sm-2"
    }, [_c('label', [_vm._v("Ações")]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-sm form-control btn-danger",
      on: {
        "click": function($event) {
          return _vm.rules.splice(index, 1)
        }
      }
    }, [_vm._v("Remover")])])])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('button', {
    staticClass: "btn btn-default pull-right",
    on: {
      "click": function($event) {
        return _vm.rules.push({})
      }
    }
  }, [_vm._v("Adicionar Regra")])]), _vm._v(" "), (_vm.show) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('label', {
    attrs: {
      "for": "select-items"
    }
  }, [_vm._v("Opções do select")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.optionsCSV),
      expression: "optionsCSV"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "select-items",
      "rows": "6",
      "placeholder": "Opções"
    },
    domProps: {
      "value": (_vm.optionsCSV)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.optionsCSV = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v("Resultado")]), _vm._v(" "), _c('div', {
    staticClass: "text-muted"
  }, [_vm._v("Verifique se os itens foram reconhecidos corretamente.")]), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered table-sprited"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.newField.options), function(item) {
    return _c('tr', {
      key: item.code
    }, [_c('td', [_vm._v(_vm._s(item.code))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.name))])])
  }), 0)])])]) : _vm._e()]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "id": "btn-save-field",
      "type": "button"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("Salvar")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("Cancelar")])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-muted"
  }, [_vm._v("Adicione os items como linhas, com duas colunas separadas por \";\" (ponto e vírgula). "), _c('b', [_vm._v("Ex: 12345; Item de Exemplo")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Identificador")]), _vm._v(" "), _c('th', [_vm._v("Descrição")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5092c482"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/FormFieldDetail.vue
// module id = 1398
// module chunks = 1